export { SvgCash } from './cash'
export { SvgMastercard } from './mastercard'
export { SvgMir } from './mir'
export { SvgVisa } from './visa'
